import { useEffect } from "react";

import { useSelector } from "react-redux";
import { useParams, useHistory } from 'react-router-dom'

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import UndoIcon from '@mui/icons-material/Undo';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';

import SaveStatus from '../../UIComponents/SaveStatus'
import GeoIconArray from '../GeoIconArray';
import LinkList from "../../UIComponents/LinkList";

import mapStateToProps from './mapStateToProps'
import { ButtonGroup } from "@mui/material";
import ColorInformer from "../ColorInformer";

const GeozoneDravingPalette = () => {
    const {
        resetVertex,
        deleteLastVertex,
        saveGeozonePolygone,
        savingGeoObjGeozone,
        geozoneVertexArr = [],
        geozoneArr = [],
        rights,
    } = useSelector(mapStateToProps);

    useEffect(()=>{
        return ()=>resetVertex()
    },[])

    const { zoneId } = useParams();
    const history= useHistory();

    if (!rights?.['dirGeozones-edit']) return null

    const gId = parseInt(zoneId);
    const editedGeo = geozoneArr.find(({ id }) => gId === id)
    if (!editedGeo) return null
    const postSave = () => {
        resetVertex()
        history.push('/')
    }
    const savePoligone = () => {
        saveGeozonePolygone(gId,geozoneVertexArr)
    }
    const OnCancel = () => {
        resetVertex()
        history.push('/')
    }

    return (
        <Card sx={{ maxWidth: "100%" }} elevation={0}>
            <CardHeader
                avatar={
                    <Avatar aria-label="recipe">
                        <GeoIconArray iconNum={editedGeo.icon} />
                    </Avatar>
                }
                title={editedGeo.name}
                subheader={editedGeo.project}
            />
            <CardContent>
                
                <Typography variant="h6" color="text.secondary">
                    Создание геозоны
                </Typography>
                <SaveStatus
                    title="Сохранение многоугольника"
                    errShowTime={6000}
                    successShowTime={100}
                    postSuccessAction={postSave}
                    dataObj={savingGeoObjGeozone}
                />
                <Typography variant="body2" color="text.secondary" gutterBottom>
                    Цвет геозоны
                    <ColorInformer color={editedGeo.color}/>
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                    Сейчас в многоугольнике {geozoneVertexArr?.length} вершин
                </Typography>
                <Button startIcon={<UndoIcon />} variant="outlined" color="primary" disabled={!geozoneVertexArr?.length} onClick={deleteLastVertex}>
                    Стереть
                </Button>
            </CardContent>
            <CardActions disableSpacing>
                <Button startIcon={<SaveIcon />} variant="contained" color="primary" disabled={!(geozoneVertexArr?.length > 2)} onClick={savePoligone}>
                    Ок
                </Button>
                <Button startIcon={<RestartAltIcon />} variant="outlined" color="primary" disabled={!geozoneVertexArr?.length} onClick={resetVertex}>
                    Сброс
                </Button>
                <Button startIcon={<CancelIcon />} variant="contained" color="error" onClick={OnCancel}>
                    Отмена
                </Button>
            </CardActions>
        </Card>
    )
    // const list = listFull.filter(({id})=>rightCheck(id))
    // const { dirname } = useParams();
    // const match = useRouteMatch();

    // useEffect(()=>{
    //     getDirectoryList()
    // },[])
    // return (
    //     <>
    //         <SaveStatus title="Загрузка списка спрвочников" dataObj={directoryList} successShowTime={100}/>
    //         {/* {list.length?list.map(({id, name})=>(<Link to={`/directory/${id}`} key={id}>{name}</Link> )):null} */}
    //         <LinkList linkArr={list.map(({id, name})=>({link:`/directory/${id}`,selected:(id===dirname), label:name}))} />
    //     </>
    // )
}

export default GeozoneDravingPalette;